// Shared epistemic taxonomy for the frontend — mirrors backend/evidence.py.
// Evidence class = "how mature is the evidence?" (quiet research metadata).
// Relationship type = "why are two records connected?".
// Content value label = "what kind of work is this?".

// Muted left-border tints per class. Deliberately restrained — no traffic-light,
// no icons, no decorative badges. Subordinate to the record content.
export const EVIDENCE_META = {
  ESTABLISHED:  { label: 'Established',  tint: '#3f7d6b', note: 'Supported by mature science/engineering, replicated mechanisms, or accepted physical principles.' },
  SUPPORTED:    { label: 'Supported',    tint: '#3E7C78', note: 'Meaningful peer-reviewed or technical evidence exists; the specific claim may still have limits.' },
  OBSERVATIONAL:{ label: 'Observational',tint: '#57708f', note: 'Documented measurements or reported observations; causal interpretation remains uncertain.' },
  EXPERIMENTAL: { label: 'Experimental', tint: '#7a6f4a', note: 'Prototype, pilot, or preliminary research; conclusions remain provisional.' },
  THEORETICAL:  { label: 'Theoretical',  tint: '#6d5f80', note: 'Mechanism, model, or hypothesis not yet adequately demonstrated empirically.' },
  INSUFFICIENT: { label: 'Insufficient Evidence', tint: '#5b626f', note: 'Retained for exploratory/comparative purposes; evidence does not justify a stronger claim.' },
  ARCHIVED:     { label: 'Archived',     tint: '#4a4a52', note: 'Historically relevant, superseded, or contradicted by stronger evidence.' },
};

export const evidenceMeta = (key) => EVIDENCE_META[(key || '').toUpperCase()] || null;

export const EVIDENCE_ORDER = [
  'ESTABLISHED', 'SUPPORTED', 'OBSERVATIONAL', 'EXPERIMENTAL', 'THEORETICAL', 'INSUFFICIENT', 'ARCHIVED',
];

export const RELATIONSHIP_META = {
  'DIRECT EVIDENCE':  { label: 'Direct Evidence',  note: 'A source explicitly connects the records through empirical evidence.' },
  'SHARED MECHANISM': { label: 'Shared Mechanism', note: 'Linked through a documented physical/chemical/biological mechanism.' },
  'SHARED VARIABLE':  { label: 'Shared Variable',  note: 'Independently associated with the same measured variable.' },
  'METHODOLOGICAL':   { label: 'Methodological',   note: 'Share measurement methods, instrumentation, or experimental design.' },
  'CONCEPTUAL':       { label: 'Conceptual',       note: 'Conceptual or taxonomic relationship only.' },
  'HYPOTHESIS':       { label: 'Hypothesis',       note: 'Proposed as a testable possibility, not an established finding.' },
  'CONTRADICTORY':    { label: 'Contradictory',    note: 'Present competing or inconsistent findings.' },
  'INSUFFICIENT':     { label: 'Insufficient',     note: 'A candidate was found, but evidence is inadequate for a stronger claim.' },
  'REJECTED':         { label: 'Rejected',         note: 'Human review rejected the suggested relationship.' },
};

export const relationshipMeta = (key) =>
  RELATIONSHIP_META[(key || '').toUpperCase()] || { label: key || 'Related', note: '' };

// Admin action set for reviewing a semantic candidate.
export const RELATIONSHIP_ACTIONS = [
  'SHARED MECHANISM', 'SHARED VARIABLE', 'METHODOLOGICAL', 'CONCEPTUAL', 'HYPOTHESIS', 'DIRECT EVIDENCE', 'CONTRADICTORY', 'INSUFFICIENT',
];
